import React from "react";
import BrochureImage from "../../images/cep/KU CEP.jpeg";
import PageLayout from "../ui/PageLayout";
import PageHero from "../ui/PageHero";
import FadeIn from "../ui/FadeIn";

const CEP = () => (
  <PageLayout>
    <PageHero title="Community Engagement Program" eyebrow="CEP" light />
    <section className="ku-section bg-white">
      <div className="ku-container max-w-4xl">
        <FadeIn>
          <img
            src={BrochureImage}
            alt="Kindness Unlimited Community Engagement Program Brochure"
            className="w-full rounded-ku-lg shadow-elevated"
          />
        </FadeIn>
      </div>
    </section>
  </PageLayout>
);

export default CEP;
